module.exports = __webpack_public_path__ + "img/new1-img7.4994cc29.png";